import * as React from 'react';
import { Container, createTheme, CssBaseline, Paper, ThemeProvider } from '@mui/material';
import 'react-phone-number-input/style.css'
import RequestCodeFragment from '../components/RequestCodeFragment';

const theme = createTheme({
    colorSchemes: {
        dark: {
            palette: {
                primary: {
                    main: '#17a2c6',
                    contrastText: 'white'
                },
            }
        },
    },
    palette: {
        primary: {
            main: '#17a2c6',
        }
    }
});

const LoginPage = (): JSX.Element => (
    <React.Fragment>
        <CssBaseline />
        <ThemeProvider theme={theme}>
            <Container sx={{ maxWidth: '10000px !important', height: '100vh', display: 'flex' }}>
                <Paper sx={{ width: '400px', height: '330px', margin: 'auto', padding: 4 }}>
                    <RequestCodeFragment />
                </Paper>
            </Container>
        </ThemeProvider>
    </React.Fragment>
)

export default LoginPage;